<template>
  <div id="canvas" class="canvas">
    <div
      id="image"
      :style="{
        backgroundImage: `url(${getBackUrl(backUrl)})`,
        backgroundColor: '#515151',
        backgroundSize: '100% 100%'
      }"
    >
      <vdr
        v-for="(items, index) in componentsList"
        v-show="!dels.includes(items.id) && items.coType !== 'background'"
        :key="items.id"
        :ref="'draggable' + index"
        :h="parseFloat(items.infoHeight) / zoom"
        :w="parseFloat(items.infoWidth) / zoom"
        :x="parseFloat(items.infoX) / zoom"
        :y="parseFloat(items.infoY) / zoom"
        :index="index"
        :id="items.id"
        :imgType="items.coType"
        :suffix="items.coType === 'doc' ? getSuffix(items) : ''"
        :parent="true"
        @dragging="handleDrag"
        @resizing="handleResize"
        @activated="handleActivated"
        @activate-tab="handleActivateTab"
      >
        <div v-if="items.coType === 'img'" class="resizable-content">
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="isImageLoaded(items.id, subIndex)"
            :key="subIndex"
            :src="getImageUrl(item.url)"
            class="img-content"
            @load="$emit('image-load', items.id, subIndex)"
            @error="$emit('image-error', items.id, subIndex)"
          />
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="!isImageLoaded(items.id, subIndex)"
            :key="'placeholder-' + subIndex"
            src="/static/images/placeholder.jpg"
            class="img-content"
          />
        </div>

        <div
          v-for="(item, subIndex) in items.txList"
          v-else-if="isTextType(items.coType)"
          :key="subIndex"
          class="resizable-content"
          :style="{ backgroundColor: item.taBgColor }"
        >
          <div
            class="text-content"
            :style="getTextContainerStyle(item.taAlignment)"
          >
            <div
              class="text-content-inner"
              :style="getTextInnerStyle(item)"
            >{{ item.taContent }}</div>
          </div>
        </div>
        <div v-else-if="items.coType === 'video'" class="resizable-content">
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="isImageLoaded(items.id, subIndex)"
            :key="subIndex"
            :src="getImageUrl(item.viewUrl)"
            class="img-content"
            @error="setFailedMaterialImage(item)"
            @load="$emit('image-load', items.id, subIndex)"
          />
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="!isImageLoaded(items.id, subIndex)"
            :key="'placeholder-' + subIndex"
            src="/static/images/placeholder.jpg"
            class="img-content"
          />
        </div>

        <div
          v-for="(item, subIndex) in items.txList"
          v-else-if="items.coType === 'streaming'"
          :key="subIndex"
          class="resizable-content"
          :style="{
            backgroundColor: item.taBgColor,
            color: item.taColor,
            fontSize: item.taFontSize + 'px'
          }"
        >
          <div class="text-content">
            <img v-if="item.taContent !== ''" src="/static/images/liumeiti.jpg" style="width: 100%; height: 100%;" />
          </div>
        </div>

        <div
          v-for="(item, subIndex) in items.txList"
          v-else-if="items.coType === 'webPage'"
          :key="subIndex"
          class="resizable-content"
          :style="{
            backgroundColor: item.taBgColor,
            color: item.taColor,
            fontSize: item.taFontSize + 'px'
          }"
        >
          <div class="text-content">
            <img v-if="item.taContent !== ''" src="/static/images/web.jpg" />
          </div>
        </div>

        <div v-else-if="items.coType === 'mixture'" class="resizable-content">
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="isImageLoaded(items.id, subIndex)"
            :key="subIndex"
            :src="getMixtureUrl(item)"
            class="img-content"
            @load="$emit('image-load', items.id, subIndex)"
            @error="$emit('image-error', items.id, subIndex)"
          />
          <img
            v-for="(item, subIndex) in items.mpList"
            v-show="!isImageLoaded(items.id, subIndex)"
            :key="'placeholder-' + subIndex"
            src="/static/images/placeholder.jpg"
            class="img-content"
          />
        </div>
      </vdr>
    </div>
  </div>
</template>

<script>
import vdr from '@/components/vue-draggable-resizable.vue'

export default {
  name: 'ProgramCanvas',
  components: {
    vdr,
  },
  props: {
    backUrl: {
      type: String,
      default: '',
    },
    zoom: {
      type: Number,
      required: true,
    },
    componentsList: {
      type: Array,
      default: () => [],
    },
    dels: {
      type: Array,
      default: () => [],
    },
    loadedImages: {
      type: Object,
      default: () => ({}),
    },

  },
  methods: {
    handleDrag(x, y) {
      this.$emit('drag', x, y)
    },
    handleResize(x, y, width, height) {
      this.$emit('resize', x, y, width, height)
    },
    handleActivated(index, type) {
      this.$emit('activated', index, type)
    },
    handleActivateTab(index) {
      this.$emit('activate-tab', index)
    },
    getActiveDraggable(index) {
      const ref = this.$refs['draggable' + index]
      return Array.isArray(ref) ? ref[0] : ref
    },
    fillActive(index) {
      const draggable = this.getActiveDraggable(index)
      if (!draggable || typeof draggable.fillParent !== 'function') return false
      draggable.fillParent()
      return true
    },
    restoreActive(index) {
      const draggable = this.getActiveDraggable(index)
      if (!draggable || typeof draggable.restoreSize !== 'function') return false
      draggable.restoreSize()
      return true
    },
    isImageLoaded(controlId, subIndex) {
      return this.loadedImages[controlId] && this.loadedImages[controlId][subIndex]
    },
    isTextType(type) {
      return ['subtitle', 'date', 'weeks', 'time'].includes(type)
    },
    getBackUrl(url) {
      if (!url) return url
      return url.startsWith('http') ? url : this.upFileUrl + url
    },
    getImageUrl(url) {
      if (!url) return '/static/images/icon_loader_failed_braseas.png'
      return url.startsWith('http') ? url : this.upFileUrl + url
    },
    getMixtureUrl(item) {
      const rawUrl = item.type === 'video' ? item.viewUrl : item.url
      const url = this.getImageUrl(rawUrl)
      return `${url}?t=${new Date().getTime()}`
    },
    getSuffix(item) {
      if (item && item.mpList && item.mpList.length !== 0) {
        return item.mpList[0].suffix
      }
      return ''
    },
    getFontSize(fontSize) {
      return fontSize / this.zoom + 'px'
    },
    setFailedMaterialImage(item) {
      item.viewUrl = 'static/images/icon_loader_failed.png'
      item.url = 'static/images/icon_loader_failed.png'
    },
    getTextContainerStyle(alignment) {
      return {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: this.alignItems(alignment),
      }
    },
    getTextInnerStyle(item) {
      return {
        width: '100%',
        fontSize: this.getFontSize(item.taFontSize),
        color: item.taColor,
        textAlign: this.textAlign(item.taAlignment),
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }
    },
    textAlign(val) {
      const map = {
        1: 'left',
        2: 'center',
        3: 'right',
        4: 'left',
        5: 'center',
        6: 'right',
        7: 'left',
        8: 'center',
        9: 'right',
      }
      return map[Number(val)] || 'center'
    },
    alignItems(val) {
      const map = {
        1: 'flex-start',
        2: 'flex-start',
        3: 'flex-start',
        4: 'center',
        5: 'center',
        6: 'center',
        7: 'flex-end',
        8: 'flex-end',
        9: 'flex-end',
      }
      return map[Number(val)] || 'center'
    },
  },

}
</script>

<style scoped lang="scss">
.canvas {
  background-color: #131212;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

#image {
  background: #ffffff;
  position: relative;
  width: 100%;
}

.resizable-content {
  overflow: hidden;
  width: 100%;
  height: 100%;

  .img-content {
    width: 100%;
    height: 100%;
  }

  .text-content {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  .text-content-inner {
    box-sizing: border-box;
  }
}
</style>
